import styled, { createGlobalStyle } from 'styled-components';

import { DSTokenMap } from '@rover/kibble/styles';
import DialogModal from '@rover/react-lib/src/components/modals/DialogModal';
import { Body, Header } from '@rover/react-lib/src/components/modals/DialogModal/DialogModalContent';

const StyledDialogModal = styled(DialogModal)`
  .ReactModal__Content--after-open {
    overflow: visible !important;
  }

  ${Header} {
    font-family: ${DSTokenMap.DISPLAY_500_FONT_FAMILY} !important;
    font-size: ${DSTokenMap.DISPLAY_500_FONT_SIZE};
    padding: 0 0 ${DSTokenMap.SPACE_6X} 0;
  }

  ${Body} {
    padding: 0;
  }
`;

export const SearchModalPerfHackStyles = createGlobalStyle<Record<string, never>>`
  body.modalClosePerfHack {
    ${StyledDialogModal} {
      display: none !important;
    }
  }
`;

export default StyledDialogModal;
